import React from 'react'
import { Platform, StatusBar, View, KeyboardAvoidingView, ImageBackground } from 'react-native';
import { Context } from '../store'
import Login from './login';
import AuthZone from './auth-zone'
import { LinearGradient } from 'expo-linear-gradient';

export default () => {
    const {
        store: { authToken }
    } = React.useContext(Context)

    return <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'} style={{flex: 1}}>
        <LinearGradient style={{height: '100%', flex: 1 }} colors={['#77af50', '#77af50','#116d6a','#116d6a', '#116d6a', '#116d6a', '#163b52']}>
            <ImageBackground style={{
                height: '100%',
                width: '100%',
                resizeMode: "cover",
            }} source={require('../assets/images/layout/feuilles.png')}>
                {Platform.OS === 'ios' && <StatusBar barStyle="default" />}
                { authToken ? <AuthZone authToken={authToken} /> : <Login /> }
            </ImageBackground>
        </LinearGradient>
    </KeyboardAvoidingView>
}